import {AnyAction} from 'redux';
import {EventReducer as State} from '../../@types/reducers';
import {
    DELETE_EVENT_SETTINGS_SUCCESS,
    EVENT_INITIALIZE_SUCCESS,
    GET_EVENT_SETTINGS_SUCCESS,
    GET_EVENTS,
    GET_EVENTS_SUCCESS,
    OrderConstants,
    SET_ORDER,
    SET_SETTINGS,
} from "../../constants/EventsConstants";
import {processEvent} from "../utils/eventUtils";
import {AlertEventObject, EventStoredObject} from '../../@types/response';

const initialState: State = {
    initializing: false,
    monitors: [],
    template: null,
    templates: [],
    settings: {
        bookmakers: [],
        bookmaker: null,
        date: 0,
        from: 1,
        to: 1,
        order: OrderConstants.DATE,
        sports: {1: true, 2: true, 5: true}
    }
};

const eventsReducer = (state = initialState, action: AnyAction): State => {
    switch (action.type) {
        case SET_SETTINGS: {
            const settings = Object.assign({}, state.settings, action.payload)
            return {
                ...state,
                settings: settings,
            }
        }
        case EVENT_INITIALIZE_SUCCESS: {
            const settings = Object.assign({}, state.settings, action.payload.settings)
            return {
                ...state,
                initializing: false,
                settings: settings,
                templates: action.payload.templates,
            };
        }
        case GET_EVENT_SETTINGS_SUCCESS: {
            return {
                ...state,
                initializing: false,
                settings: action.payload.settings,
                template: action.payload.template
            };
        }
        case DELETE_EVENT_SETTINGS_SUCCESS: {
            return {
                ...state,
                templates: state.templates.filter((item: string) => item !== action.payload.template)
            };
        }
        case GET_EVENTS: {
            return {
                ...state,
                initializing: true
            }
        }
        case GET_EVENTS_SUCCESS: {
            const monitors: AlertEventObject[] = action.payload.events.map((e: EventStoredObject) => processEvent(e, state.settings)).flat()
            return {
                ...state,
                monitors,
                initializing: false
            };
        }
        case SET_ORDER: {
            return {
                ...state,
                settings: Object.assign({}, state.settings, {order: action.payload})
            };
        }
        default:
            return state;
    }
};

export default eventsReducer;
